import { useState, createContext } from 'react';

export const SidebarContext = createContext({});

const SIDEBAR_EXPANDED_STORAGE_KEY = 'autoclever.sidebar.expanded';

const initialExpandedState = () => {
  if (typeof window === 'undefined') return true;
  return window.localStorage.getItem(SIDEBAR_EXPANDED_STORAGE_KEY) !== 'false';
};

export const SidebarProvider = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(initialExpandedState);
  const toggleSidebar = () => {
    setSidebarToggle((current) => !current);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };
  const toggleSidebarExpanded = () => {
    setSidebarExpanded((current) => {
      const next = !current;
      window.localStorage.setItem(SIDEBAR_EXPANDED_STORAGE_KEY, String(next));
      return next;
    });
  };

  return (
    <SidebarContext.Provider
      value={{
        sidebarToggle,
        sidebarExpanded,
        toggleSidebar,
        closeSidebar,
        toggleSidebarExpanded
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
